/**
 * Parses the opaque preferences JSON blob into a typed object. Falls back to
 * `fallback` when the value is missing or malformed, so a screen with no
 * preferences registered yet (or a corrupted payload) never breaks rendering.
 */
export const parsePreferences = <T extends Record<string, unknown>>(
  preferencesJson: string,
  fallback: T,
): T => {
  try {
    const parsed = JSON.parse(preferencesJson);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return { ...fallback, ...parsed };
    }
    return fallback;
  } catch {
    return fallback;
  }
};

/** Serializes a typed preferences object back into the opaque JSON blob the API expects. */
export const serializePreferences = <T>(value: T): string => JSON.stringify(value);
